/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getLocationByZipCode,
  fetchDrugs,
  fetchPopularDrugs,
  getIp
} from '../../services/Api/SearchBar/SearchBarService';
import {
  DRUGNAME_QUERY_PARAMETER,
  ONLY_NUMBER_REGEX,
  DEFAULT_ZIPCODE,
  DEFAULT_ZIPCODE_CITY_AND_REGION,
  COOKIES_ZIPCODE,
  COOKIE_SIX_MONTH_EXPIRY_TIME,
  INTELLIMIZE_HOMEPAGE_SEARCHBAR_CLICK
} from '../../constants/defaults';
import _ from 'lodash';
import SearchDropdown from '../Prescription/SearchDropdown/index.jsx';
import { withRouter } from 'react-router-dom';
import path from '../../constants/route';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getIsMobileDevice } from '../../../singlecare-chart/src/utilities';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drug: '',
      drugSearchResults: [],
      drugSuggestionDropdown: false,
      noDrugFound: false,
      locationDropdown: false,
      invalidLocation: false,
      locationZip: '',
      isPopular: false,
      showDummyLoader: false,
      homePage: false,
      submitId: 0
    };
    this.getDrugsDelayedCallback = _.debounce(this.getDrugs, 500);
    this.getLocationDelayedCallback = _.debounce(this.getLocation, 500);
    this.getonBlurHandlerForSearchBarCallback = _.debounce(
      this.blurHandlerForSearchBar,
      250
    );
    this.inputRef = React.createRef();
    this.searchBarRef = React.createRef();
  }
  async componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClickOrFocus);
    document.addEventListener('focusout', this.handleOutsideClickOrFocus);
    if (
      typeof window !== 'undefined' &&
      _.includes(path.searchDropDownVisibility, window.location.pathname)
    ) {
      this.setState({ homePage: true });
    }
    const url_string = typeof window !== 'undefined' && window.location.href;
    const url = new URL(url_string);
    const drugName = url.searchParams.get(DRUGNAME_QUERY_PARAMETER);
    const pathName = typeof window !== 'undefined' && window.location.pathname;
    const n = pathName.lastIndexOf('/');
    const seoName = pathName.substring(n + 1);
    if (drugName) {
      _.saveRecentlyViewedDrugs(seoName, drugName);
    }
    const zipCodeData =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('zipCodeData') &&
      JSON.parse(localStorage.getItem('zipCodeData'));

    if (_.isEmpty(zipCodeData) || zipCodeData.zipCode === '00000') {
      const location = await getIp();
      if (
        location.status &&
        location.status === 200 &&
        location.data.state &&
        location.data.zipCode &&
        location.data.zipCode.length === 5 &&
        location.data.zipcode !== '00000'
      ) {
        localStorage.setItem('zipCodeData', JSON.stringify(location.data));
        const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
        const { city, state } = zipCodeData;
        this.setState({
          locationZip: city + ', ' + state
        });
      } else {
        _.setDefaultLocation();
        this.setState({
          locationZip: DEFAULT_ZIPCODE_CITY_AND_REGION
        });
      }
    } else {
      const { city, state, City, Region } = zipCodeData;
      this.setState({
        locationZip: `${city || City}, ${state || Region}`
      });
    }
    if (zipCodeData.zipCode)
      _.setCookie(
        COOKIES_ZIPCODE,
        zipCodeData.zipCode,
        COOKIE_SIX_MONTH_EXPIRY_TIME
      );
  }

  componentDidUpdate(prevProps) {
    const zipCodeData =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('zipCodeData') &&
      JSON.parse(localStorage.getItem('zipCodeData'));
    if (!_.isEmpty(zipCodeData)) {
      const { city, state, City, Region } = zipCodeData;
      let locationZip = `${city || City}, ${state || Region}`;
      if (!_.isEqual(this.props.zipCode, prevProps.zipCode)) {
        this.setState({ locationZip: locationZip });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClickOrFocus);
    document.removeEventListener('focusout', this.handleOutsideClickOrFocus);
  }

  handleOutsideClickOrFocus = (event = { preventDefault() {} }) => {
    if (
      this.searchBarRef.current &&
      !this.searchBarRef.current.contains(event.target)
    ) {
      this.setState({
        drugSuggestionDropdown: false,
        noDrugFound: false,
        isPopular: false
      });
    }
  };

  getDrugs(drugName) {
    this.isDirty = true;
    if (_.isEmpty(drugName.trim())) {
      // When user removes all the text from input
      this.getPopularDrugs();
    } else {
      fetchDrugs(drugName)
        .then(res => {
          const drugSearchResults = res;
          if (!_.isEmpty(drugSearchResults)) {
            this.setState({
              drugSearchResults: drugSearchResults,
              drugSuggestionDropdown: true,
              noDrugFound: false,
              isPopular: false
            });
          } else {
            this.setState({
              drugSearchResults: drugSearchResults,
              drugSuggestionDropdown: false,
              noDrugFound: true,
              isPopular: false
            });
          }
        })
        .catch(() => {
          this.setState({
            drugSearchResults: [],
            drugSuggestionDropdown: false,
            noDrugFound: true,
            isPopular: false
          });
        });
    }
  }

  handleSearchBarClick = () => {
    _.sendIntellimizeEvent(INTELLIMIZE_HOMEPAGE_SEARCHBAR_CLICK);
    this.getPopularDrugs();
  };

  getPopularDrugs(event = { target: { value: '' } }) {
    const { value } = event.target;
    if (!_.isEmpty(value) && this.isDirty) {
      this.setState({ drug: value });
      this.getDrugsDelayedCallback(value);
      return;
    }
    if (!this.fetchTopDrugs && !this.state.drugSuggestionDropdown) {
      let dataBy =
        document?.getElementById('searchbar')?.getAttribute('data-revenue') ===
        'true'
          ? 'revenue'
          : 'script';
      this.fetchTopDrugs = true;
      fetchPopularDrugs(dataBy).then(res => {
        const drugSearchResults = _.slice(res, 0, 5);
        if (!_.isEmpty(drugSearchResults)) {
          this.setState(
            {
              drugSearchResults: drugSearchResults,
              drugSuggestionDropdown: true,
              noDrugFound: false,
              isPopular: true
            },
            () => {
              this.fetchTopDrugs = false;
            }
          );
        }
      });
    }
  }

  getLocation(zipCode) {
    const regx = ONLY_NUMBER_REGEX;
    if (
      typeof zipCode === 'string' &&
      !_.isUndefined(zipCode) &&
      !_.isEmpty(zipCode) &&
      (!zipCode || !regx.test(zipCode))
    ) {
      this.setState({
        locationDropdown: false,
        invalidLocation: true
      });
    } else {
      if (
        typeof zipCode === 'string' &&
        !_.isUndefined(zipCode) &&
        !_.isEmpty(zipCode) &&
        zipCode.length === 5
      ) {
        getLocationByZipCode(zipCode)
          .then(res => {
            const locationSearchResults =
              res.status === 200 ? res : res.response;
            if (
              locationSearchResults &&
              locationSearchResults.status === 200 &&
              locationSearchResults.data !== null
            ) {
              this.setState({
                invalidLocation: false,
                locationDropdown: false
              });
              localStorage.setItem(
                'zipCodeData',
                JSON.stringify(locationSearchResults.data)
              );
              _.setCookie(
                COOKIES_ZIPCODE,
                zipCode,
                COOKIE_SIX_MONTH_EXPIRY_TIME
              );
              const { city, state } = locationSearchResults.data;
              this.setState({
                locationZip: city + ', ' + state
              });
              this.props.handleZipCodeChange(zipCode);
            } else {
              this.setState({
                invalidLocation: true,
                locationDropdown: false
              });
            }
          })
          .catch(() => {
            this.setState({
              invalidLocation: true,
              locationDropdown: false
            });
          });
      } else {
        const location = zipCode && zipCode.data;
        if (!_.isEmpty(location)) {
          const { city, state, zipCode } = location;
          this.setState({
            locationDropdown: false
          });
          localStorage.setItem('zipCodeData', JSON.stringify(location));
          this.setState({
            locationZip: city + ', ' + state
          });
          this.props.handleZipCodeChange(zipCode);
        } else {
          this.setState({
            invalidLocation: false,
            locationDropdown: true
          });
        }
      }
    }
  }

  searchDrug(event = { preventDefault() {} }) {
    const { value } = event.target;
    this.setState({ drug: value, drugSearchResults: [], isPopular: false });
    this.getDrugsDelayedCallback(value);
  }

  searchLocation(event = { preventDefault() {} }) {
    const { value } = event.target;
    this.setState({ locationZip: value });
    this.getLocationDelayedCallback(value);
  }

  showLocationDropdown() {
    const zipCodeData =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('zipCodeData') &&
      JSON.parse(localStorage.getItem('zipCodeData'));
    if (!_.isEmpty(zipCodeData)) {
      const { zipCode, zip, city, state } = zipCodeData;
      if (this.state.locationZip !== city + ', ' + state) {
        this.props.handleZipCodeChange(zipCodeData.zipCode);
      }
      this.setState({
        noDrugFound: false,
        locationDropdown: true,
        locationZip: !zipCode ? zip : zipCode
      });
    } else {
      this.setState({
        noDrugFound: false,
        locationDropdown: true,
        locationZip: DEFAULT_ZIPCODE
      });
    }
  }

  searchDrugFocusHandle(event = { preventDefault() {} }) {
    event.preventDefault();
    if (_.isEmpty(this.state.drug)) {
      this.getPopularDrugs();
      return;
    }
  }

  onBlurHandler() {
    this.getonBlurHandlerForSearchBarCallback();
  }

  blurHandlerForSearchBar() {
    //added isSafari check to handle iphone 'done' button click
    const isSafari =
      typeof window !== 'undefined' &&
      /^((?!chrome|android).)*safari|iPad|iPod|iPhone/.test(
        window?.navigator?.userAgent
      );
    if (!isSafari && !getIsMobileDevice())
      this.setState({ drugSuggestionDropdown: false, noDrugFound: false });
  }

  blurHandlerForZipCode() {
    const zipCodeData =
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('zipCodeData') &&
      JSON.parse(localStorage.getItem('zipCodeData'));
    if (zipCodeData) {
      const { city, state } = zipCodeData;
      this.setState({
        locationZip: city + ', ' + state
      });
    } else {
      this.setState({
        locationZip: DEFAULT_ZIPCODE_CITY_AND_REGION
      });
    }
    setTimeout(() => {
      this.setState({
        locationDropdown: false,
        invalidLocation: false,
        drugSuggestionDropdown: false
      });
    }, 500);
  }

  submitResult(submitId, key = '', searchType = '') {
    const search_bar_entry =
      key == 'Enter' || key == 'Search Button'
        ? this.state.drug
        : this.state.drugSearchResults?.[submitId]?.displayName;
    _.triggerGTMVirtualPageViewEvent({
      event: 'web_script_search_tracking',
      search_bar_entry
    });

    const { i18n } = this.props;
    const pagePath = this.props.history.location.pathname;
    if (!_.isEmpty(this.state.drugSearchResults[submitId].displayName)) {
      this.setState(
        { showDummyLoader: true, submitId, drugSuggestionDropdown: false },
        () => {
          setTimeout(
            () => {
              let redirectPath = _.withLocale(i18n.language, '/prescription');
              // passed "isHomeSearch" as true for AB test Triggered only after drug search from the homepage
              window.location.assign(
                `${redirectPath}/${
                  this.state.drugSearchResults[submitId].seoName
                }?q=${
                  this.state.drugSearchResults[submitId].displayName
                }&isHomeSearch=${pagePath === '/'}`
              );
              // Reset all unnecessary values to default
              this.props.handleDropDownClick();
              this.setState({
                drug: this.state.drugSearchResults[submitId].displayName,
                drugSearchResults: [],
                drugSuggestionDropdown: false,
                noDrugFound: false,
                locationDropdown: false,
                invalidLocation: false,
                isPopular: false,
                homePage: false
              });
              this.props.handleSearchSubmitOverLay();
              if (pagePath === '/medicare') {
                _.triggerGTMVirtualPageViewEvent({
                  event: 'prescriptionSearchSubmit'
                });
              }
            },
            this.props.isFromHeader ? 0 : 850
          );
        }
      );
    }
  }

  handleSubmit = (submitId, key = '', searchType = '') => {
    // To handle form submit
    if (_.isFunction(submitId.preventDefault)) submitId.preventDefault();

    // To handle click/keyboard submission
    this.submitResult(submitId, key, searchType);
  };

  handleLocation = location => {
    const zipCodeData = localStorage.getItem('zipCodeData');
    if (
      location.status &&
      location.status === 200 &&
      location.data.state &&
      location.data.zipCode &&
      location.data.zipCode.length === 5 &&
      zipCodeData
    ) {
      this.getLocationDelayedCallback(location);
    } else {
      if (_.isEmpty(zipCodeData)) {
        const defaultLocation = { data: _.setDefaultLocation() };
        this.getLocationDelayedCallback(defaultLocation);
      }
    }
  };

  handleIp = location => {
    const zipCodeData = localStorage.getItem('zipCodeData');
    if (
      location.status &&
      location.status === 200 &&
      location.data.state &&
      location.data.zipCode &&
      location.data.zipCode.length === 5 &&
      zipCodeData
    ) {
      this.setState({
        locationSearchResults: location.data,
        invalidLocation: false,
        locationDropdown: false
      });
      localStorage.setItem('zipCodeData', JSON.stringify(location.data));
      const { city, state, zipCode } = location.data;
      this.setState({
        locationZip: city + ', ' + state
      });
      this.props.handleZipCodeChange(zipCode);
    } else {
      if (_.isEmpty(zipCodeData)) {
        _.setDefaultLocation();
        this.setState({
          locationZip: DEFAULT_ZIPCODE_CITY_AND_REGION
        });
        this.props.handleZipCodeChange(DEFAULT_ZIPCODE);
      }
    }
  };

  handleSearchClick = (event = { preventDefault() {} }) => {
    event.preventDefault();
    // window.intellimize.activate();
    this.submitResult(this.state.submitId, 'Search Button', 'Typed Search');
  };

  setSubmitId = submitId => {
    this.setState({ submitId });
  };

  clearSearchValue = event => {
    event.preventDefault();
    event.stopPropagation();
    this.setState(
      {
        drug: ''
      },
      () => {
        this.handleSearchBarClick();
        this.inputRef.current && this.inputRef.current.focus();
      }
    );
  };

  render() {
    const { showDummyLoader, submitId } = this.state;
    const { buttonPlaceHolder, aria, tabIndex, inputPlaceHolder } = this.props;
    const { t } = this.props;
    const adaSearchError = this.state.noDrugFound && {
      'aria-describedby': 'drugNameError',
      'aria-invalid': true
    };

    const adaRoleLabel = this.state.drugSuggestionDropdown
      ? {
          role: 'region',
          'aria-live': 'assertive',
          'aria-label': t('ada suggestion drug message')
        }
      : { 'aria-label': t('Search drugs label') };

    return (
      <div>
        <section
          className={`${
            this.props.classes ? this.props.classes : 'search-masthead'
          }`}
        >
          <div
            id="vm-search"
            className="site-search open"
            role="search"
            {...aria}
            ref={this.searchBarRef}
          >
            <div
              className={`site-search-form ${
                !this.props.showZipCode && 'search-center'
              }`}
            >
              {!this.props.hideTextSearch && (
                <form
                  autoComplete="off"
                  className={
                    this.props.showMobileSearchBar
                      ? 'search-form-wd-false'
                      : 'search-form-wd'
                  }
                  onSubmit={this.handleSubmit.bind(this)}
                >
                  <div
                    className={`site-search-form--query ${
                      showDummyLoader && 'active'
                    } ${this.props.textSearchClasses}`}
                  >
                    <LazyLoadImage
                      alt=""
                      src="/content/images/homepage-new/SearchIcon.svg"
                      className="search-img newSearchIcon d-none"
                      height="32"
                      width="20"
                    />
                    <LazyLoadImage
                      alt=""
                      src="/content/images/icons/search.jpg"
                      className="search-img"
                      height="32"
                      width="20"
                      loading="lazy"
                    />
                    <LazyLoadImage
                      src="/content/images/medicare/Search-Icon-pink.svg"
                      className="search-img medicareSearchIcon d-none"
                      alt=""
                      height="24"
                      width="24"
                    />
                    <div className="newTitleAB">
                      <h1 className="mainHeading">
                        <span className="mobileHeader mobile-only">
                          Real Prescription Savings.
                        </span>
                        <span className="mobileHeader mobile-only swoosh">
                          Really.
                        </span>
                      </h1>
                    </div>
                    <div className="whitebg-AB"></div>
                    <div className="fullwidth position-relative">
                      <span className="searchTitle">
                        {t('Got a prescription? Get a')}{' '}
                        <span className="subtext">{t('coupon')}</span>.
                      </span>

                      <input
                        className={`${
                          showDummyLoader && 'active'
                        } sc-form__text site-search-form--term whiteFocus`}
                        id="searchbar"
                        placeholder={
                          inputPlaceHolder
                            ? inputPlaceHolder
                            : t('Search drugs label')
                        }
                        value={this.state.drug}
                        onChange={this.searchDrug.bind(this)}
                        onFocus={this.searchDrugFocusHandle.bind(this)}
                        onClick={this.handleSearchBarClick}
                        autoComplete="off"
                        type="search"
                        ref={this.inputRef}
                        data-revenue="true"
                        aria-required="true"
                        aria-autocomplete="list"
                        aria-controls="site-search-results"
                        aria-activedescendant={`option-${this.state.submitId}`}
                        autoFocus={this.props.shouldFocus}
                        {...adaSearchError}
                        {...adaRoleLabel}
                      />
                      {!_.isEmpty(this.state.drug) && (
                        <button
                          onBlur={this.onBlurHandler.bind(this)}
                          className="closeSearch"
                          onClick={this.clearSearchValue}
                          aria-label={t('Clear search text')}
                        >
                          <img
                            className="removeSearch"
                            src="/content/images/icons/search-close-icon.png"
                            alt={t('Remove search')}
                          />
                          <img
                            className="abTestClearBtn hide"
                            src="/content/images/icons/searchCloseIcon.svg"
                            alt={t('Remove search')}
                          />
                        </button>
                      )}
                    </div>
                    {showDummyLoader ? (
                      <div className="mainSearchLoader">
                        <LazyLoadImage
                          src="/content/images/loader/loading.gif"
                          className="searchBarLoader desktop-only"
                          alt="loader"
                        />
                        <LazyLoadImage
                          src="/content/images/loader/loading.gif"
                          className="searchBarLoader mobile-only"
                          alt="loader"
                        />
                      </div>
                    ) : (
                      <button
                        type="submit"
                        value="Search"
                        className="search-btn sc-outline-btn--cool-gray desktop-only whiteFocus"
                        data-testid="submit"
                        onClick={this.handleSearchClick}
                      >
                        <span className="search-icon">
                          <LazyLoadImage
                            src="/content/images/header/icon-searchNew.svg"
                            height="24"
                            width="24"
                            alt=""
                          />
                        </span>
                        <span>{`${
                          buttonPlaceHolder ? buttonPlaceHolder : t('Search')
                        }`}</span>
                      </button>
                    )}
                  </div>
                </form>
              )}
            </div>
            <SearchDropdown
              listItems={this.state.drugSearchResults}
              drugSuggestionDropdown={this.state.drugSuggestionDropdown}
              locationDropdown={this.state.locationDropdown}
              noDrugFound={this.state.noDrugFound}
              drug={this.state.drug}
              invalidLocation={this.state.invalidLocation}
              isPopular={this.state.isPopular}
              homePage={this.state.homePage}
              handleSubmit={this.handleSubmit}
              handleLocation={this.handleLocation}
              handleIp={this.handleIp}
              submitId={submitId}
              setSubmitId={this.setSubmitId}
            />
          </div>
        </section>
      </div>
    );
  }
}
SearchBar.propTypes = {
  showZipCode: PropTypes.bool,
  showMobileSearchBar: PropTypes.bool,
  textSearchClasses: PropTypes.string,
  handleSearchSubmitOverLay: PropTypes.func,
  handleDropDownClick: PropTypes.func,
  history: PropTypes.object,
  hideTextSearch: PropTypes.bool,
  shouldFocus: PropTypes.bool,
  Name: PropTypes.string,
  handleZipCodeChange: PropTypes.func,
  showv2Param: PropTypes.bool,
  handleSearchSubmit: PropTypes.func,
  inputPlaceHolder: PropTypes.string,
  buttonPlaceHolder: PropTypes.string,
  classes: PropTypes.string,
  isFromHeader: PropTypes.bool,
  aria: PropTypes.object,
  tabIndex: PropTypes.string
};

SearchBar.defaultProps = {
  showZipCode: true,
  showMobileSearchBar: false,
  textSearchClasses: '',
  handleSearchSubmitOverLay: () => {},
  handleDropDownClick: () => {},
  history: {
    push: () => {}
  },
  hideTextSearch: false,
  shouldFocus: false,
  Name: '',
  handleZipCodeChange: () => {},
  showv2Param: false,
  handleSearchSubmit: () => {},
  inputPlaceHolder: '',
  buttonPlaceHolder: '',
  classes: '',
  isFromHeader: false,
  aria: { 'aria-label': 'Search drugs label' },
  tabIndex: '0'
};

export default withRouter(withTranslation()(SearchBar));
